import React from 'react'

export default props =>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" {...props}><g><g clipPath="url(#clip-78399830-72bb-4bb0-bb06-16970165d4b9)"><path d="M18 18h-6l2.3-2.3-2.89-2.87 1.42-1.42 2.87 2.89L18 12zM0 18v-6l2.3 2.3 2.87-2.89 1.42 1.42L3.7 15.7 6 18zM0 0h6L3.7 2.3l2.89 2.87-1.42 1.42L2.3 3.7 0 6zm18 0v6l-2.3-2.3-2.87 2.89-1.42-1.42L14.3 2.3 12 0z" /></g></g></svg>
